import { render } from "./UiLayer.vue?vue&type=template&id=451b3c80"
import script from "./UiLayer.vue?vue&type=script&lang=js"
export * from "./UiLayer.vue?vue&type=script&lang=js"

import "./UiLayer.vue?vue&type=style&index=0&id=451b3c80&lang=scss"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__